import angular from 'angular'
import routers from './routers.js'
import declarationTaskTrackingCtrl from './declarationTaskTrackingCtrl.js'

export default angular
  .module('declaration.personalIncomeTax.declarationTaskTracking', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('declarationTaskTrackingCtrl', declarationTaskTrackingCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/declarationTaskTracking/index.js